import React, { FC } from "react";

import {
  useProvidersCurrentEmployee,
  useManagerCategoryDisplayOrderSearch,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import { CategoryDisplayOrderChange } from "~/components/organisms";

import { ApiManagersSalesConceptCategoriesDisplayOrderIndex } from "~/domains";

export const ManagersSalesConceptCategoriesDisplayOrderIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const fetchUrl = (id: string) => {
    return `/api/managers/business_sections/${id}/sales_concept_categories`;
  };

  const updateUrl = (id: string) => {
    return `/api/managers/business_sections/${id}/sales_concept_category/display_order`;
  };

  const { onSearchSubmit, fetch, divisionSection, changeDisplayOrder } =
    useManagerCategoryDisplayOrderSearch<ApiManagersSalesConceptCategoriesDisplayOrderIndex>(
      {
        selectableBusinessDivisions: currentEmployee?.businessDivisions || [],
        selectableBusinessSections: currentEmployee?.businessSections || [],
        fetchUrl: fetchUrl,
        updateUrl: updateUrl,
      },
    );

  const breadCrumbItems = [
    { label: "ブログ", href: "/managers/sales_concept_categories" },
    {
      label: "並び替え",
      href: "/managers/sales_concept_category/display_orders",
    },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        <CategoryDisplayOrderChange
          onSearchSubmit={onSearchSubmit}
          fetch={{
            loading: fetch.loading,
            error: fetch.error,
            items: fetch.data?.salesConceptCategories || [],
          }}
          divisionSection={divisionSection}
          changeDisplayOrder={changeDisplayOrder}
          catchTitle="ブログの並び替え"
          noContentMessage="ブログがありません"
        />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
